<template>
  <GlobalWindow
      width="80%"
    :title="title"
    :visible.sync="visible"
    v-loading="isUploading"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" label-width="130px" label-suffix="：" :rules="rules"  >
      <el-form-item label="标题" prop="name">
        <el-input v-model="form.name" placeholder="请输入标题" v-trim/>
      </el-form-item>
      <el-form-item label="主图" prop="imgurlfull">
        <UploadAvatarImage
            :file="{ 'imgurlfull': form.imgurlfull, 'imgurl': form.imgurl }"
            @uploadSuccess="uploadAvatarSuccess"
            :uploadData="{folder:'activity'}"
            @uploadEnd="isUploading=false"
            @uploadBegin="isUploading = true"
        />
      </el-form-item>
      <el-form-item label="所属分类" prop="labelId">
        <el-select
          v-model="form.labelId"
          placeholder="请选择所属分类"
          filterable
          clearable
        >
          <el-option v-for="item in labels()" :key="item.id" :value="item.id" :label="item.name" />
        </el-select>
      </el-form-item>
      <el-form-item label="所属品牌" prop="brandId">
        <el-select
          v-model="form.brandId"
          placeholder="请选择所属品牌"
          filterable
          clearable
        >
          <el-option v-for="item in brands()" :key="item.id" :value="item.id" :label="item.name" />
        </el-select>
      </el-form-item>
      <el-form-item label="内容类型" prop="contentType" >
        <el-radio-group v-model="form.contentType">
          <el-radio :label="0" value="0">富文本</el-radio>
          <el-radio :label="1" value="1">外链</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="详情" prop="content" required>
        <el-input v-if="form.contentType == 1"  v-model="form.content" placeholder="请输入外链地址" v-trim/>
        <RichEditor v-else  :richData="form.content" :styleEditor="styleEditor" @getWangedditor="getWangedditor" :readonly="false"/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
import RichEditor from '@/components/common/RichEditor'
import UploadAvatarImage from '@/components/common/UploadAvatarImage'

import { fetchList as shopList } from '@/api/business/shop'

export default {
  name: 'OperaActivityWindow',
  extends: BaseOpera,
  components: { GlobalWindow, RichEditor, UploadAvatarImage },
  data () {
    return {
      styleEditor: 'border: 1px solid #ccc;display: inline-block;height:500px;',
      isUploading: false,
      searchLoading: false,
      shops: [],
      // 表单数据
      form: {
        id: null,
        name: '',
        labelId: '',
        imgurlfull: null,
        imgurl: null,
        brandId: '',
        content: '',
        contentType: 0,
        type: 3 //资讯
      },
      // 验证规则
      rules: {
        name: [
          { required: true, message: '请输入标题', tigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入内容', tigger: 'blur' }
        ],
        contentType: [
          { required: true, message: '请选择内容类型' }
        ],
        labelId: [
          { required: true, message: '请选择所属分类' }
        ],
        brandId: [
          { required: true, message: '请选择所属品牌' }
        ]
      }
    }
  },
  inject: ['labels', 'brands'],
  created () {
    this.config({
      api: '/business/activity',
      'field.id': 'id'
    })
  },
  methods: {
    // 上传图片
    uploadAvatarSuccess(file) {
      this.form.imgurl = file.imgurl;
      this.form.imgurlfull = file.imgurlfull;
    },
    getWangedditor(val){
      this.form.content =val
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/alertstyle.scss";
::v-deep .el-form-item__content {
  flex: 0.6;
}
::v-deep .el-select {
  width: 100%;
  .el-input__inner {
    width: 100%;
  }
}
$image-width: 100px;
.avatar-uploader {
  width: $image-width;
  height: $image-width;
}
::v-deep .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  width: $image-width;
  height: $image-width;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: $image-width;
  height: $image-width;
  line-height: $image-width;
  text-align: center;
}
.avatar {
  width: $image-width;
  height: $image-width;
  display: block;
}
</style>
